import pickBy from 'lodash/pickBy';
import omit from 'lodash/omit';

import {
  FETCH_ORDERS_PENDING, FETCH_ORDERS_SUCCESS, FETCH_ORDERS_ERROR, UPDATE_ORDER, DELETE_ORDER
} from "./constants";



const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ORDERS_PENDING:
      return { ...state, loading: true, error: null };

    case FETCH_ORDERS_SUCCESS:
      return { data: action.payload.data.reduce((acc, next) => {
        acc[next.id] = next;
        return acc;
      }, {}), count: action.payload.count, loading: false, error: null };

    case FETCH_ORDERS_ERROR:
      return { ...state, loading: false, error: action.error };

    case UPDATE_ORDER:
      return { ...state, data: {
        ...state.data,
        ...(state.data && action.payload && state.data[action.payload.orderId]) ? {[action.payload.orderId]: {
            ...state.data[action.payload.orderId],
            ...pickBy(action.payload, (value) => value !== 'orderId')
          }} : {}
      }};

    case DELETE_ORDER:
      const removedOrder = {...state, data: {
          ...state.data,
      }};
      if (removedOrder && removedOrder.data && action.payload && removedOrder.data[action.payload.orderId]) {
        delete removedOrder.data[action.payload.orderId];
        removedOrder.count = removedOrder.count - 1;
      }
      return removedOrder;

    default:
      return state;
  }
};
